var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 21,
    fill: "none",
    viewBox: "0 0 10 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DECE82",
    d: "M5.857.42a.573.573 0 01.841 0L9.26 2.982a.573.573 0 010 .842L3.857 9.225c-.666.667-.666 1.438 0 2.105l5.718 5.717a.573.573 0 010 .842l-2.56 2.56a.573.573 0 01-.843 0l-4.805-4.805c-.316-.316-.421-.561-.421-.982v-8.7c0-.49.105-.736.386-1.016L5.857.42z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.44b8f1a81a630db4aed7644b13d223fc.svg";
export { ForwardRef as ReactComponent };